import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
const _excluded = ["connectToDevTools", "disableOffline", "possibleTypes", "onDbUpgrade", "typePolicies", "dataIdFromObject"];
import { ApolloClient, ApolloLink, createHttpLink, fromPromise, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
// Generated schema introspection
import { createOfflineLink } from "./links/offlineLink.js";
function buildLinks({
  uri,
  getToken,
  onTokenInvalid,
  getLocale,
  customHttpFetch
}, offlineLink) {
  // Use custom http fetcher if provided (e.g. Api Metrics)
  const baseHttpLinkOptions = {
    uri
  };
  const httpLinkOptions = !customHttpFetch ? baseHttpLinkOptions : _extends({}, baseHttpLinkOptions, {
    fetch: customHttpFetch
  });
  const httpLink = createHttpLink(httpLinkOptions);

  // This Link will set the authorization header with the jwt fetched from auth module on each request
  const authLink = setContext(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (_request, {
      headers
    }) {
      const token = yield getToken();
      return {
        headers: _extends({}, headers, {
          authorization: token ? `Bearer ${token}` : ''
        })
      };
    });
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());

  // This link will set the Accept-Language header from the current store value on each request
  const i18nLink = setContext((_request, {
    headers
  }) => {
    return {
      headers: _extends({}, headers, {
        'Accept-Language': getLocale()
      })
    };
  });
  const errorLink = onError(({
    response,
    graphQLErrors,
    networkError,
    forward,
    operation
  }) => {
    if (graphQLErrors) {
      const jwtErrors = ['JwtTokenInvalidError', 'JwtTokenExpiredError'];
      const isJwtError = error => error.type && jwtErrors.includes(error.type);
      const containsJwtErrors = graphQLErrors.some(isJwtError);
      if (containsJwtErrors) {
        onTokenInvalid();
        fromPromise(getToken()).flatMap(token => {
          if (token) {
            // Modify the operation context with the new token
            const oldHeaders = operation.getContext().headers;
            operation.setContext({
              headers: _extends({}, oldHeaders, {
                authorization: token
              })
            });
            // Retry the request with the new token
            return forward(operation);
          }
          // In case token retrieval fails, return the original operation without retry
          return forward(operation);
        });
      }
    }
    if (response && graphQLErrors && !networkError) {
      response.errors = undefined;
    }
  });

  // This maps the links one after another, links will be executed in series
  const links = [authLink, i18nLink, errorLink, offlineLink, httpLink].filter(link => Boolean(link));
  return ApolloLink.from(links);
}
const defaultParams = {
  onDbUpgrade: () => void 0,
  typePolicies: {}
};

/**
 * Instantiate and returns a new graphql client
 */
export function createClient(params) {
  const _defaultParams$params = _extends({}, defaultParams, params),
    {
      connectToDevTools,
      disableOffline,
      possibleTypes,
      onDbUpgrade,
      typePolicies,
      dataIdFromObject
    } = _defaultParams$params,
    gqlParams = _objectWithoutPropertiesLoose(_defaultParams$params, _excluded);
  const safeConnectToDevtools = connectToDevTools && typeof window !== 'undefined';

  // Apollo Client cache uses introspection to ensure proper normalization of relationships cache
  const cache = new InMemoryCache({
    possibleTypes,
    typePolicies,
    dataIdFromObject
  });
  const offlineLink = disableOffline ? undefined : createOfflineLink({
    possibleTypes,
    onDbUpgrade
  });
  const client = new ApolloClient(_extends({}, gqlParams, {
    connectToDevTools: safeConnectToDevtools,
    cache,
    link: buildLinks(params, offlineLink)
  }));
  if (safeConnectToDevtools) {
    // Expose the client on the window for the Apollo Devtools extension
    window.__APOLLO_CLIENT__ = client;
  }
  const offlineApi = {
    enabled: !disableOffline,
    query: options => client.query(_extends({}, options, {
      // We use network-only in order to bypass the first inMemoryCache and let the request hit the offlineCache
      fetchPolicy: 'network-only',
      context: _extends({}, options.context, {
        offline: true
      })
    })),
    gc: queriesToKeep => {
      if (offlineLink) {
        offlineLink.gc(queriesToKeep);
      }
    }
  };
  return Object.assign(client, {
    offline: offlineApi
  });
}
//# sourceMappingURL=createClient.js.map